export enum AlertIdsEnum {
  companyProfessionalPartWarning = 'companyProfessionalPartWarning',
  settings_reminders_info = 'settings_reminders_info',
  otherRevenueGermanCarUsage = 'otherRevenueGermanCarUsage',
  settingsGermanCarsList = 'settingsGermanCarsList',
  expenseSoftwareInvoice = 'expenseSoftwareInvoice',
  revenuesListPeppolOnboarding = 'revenuesListPeppolOnboarding',
  activateAccountableBankingCard = 'activateAccountableBankingCard',
  activateAccountableBankingCard2 = 'activateAccountableBankingCard2',
  walletBanner = 'WALLET_BANNER',
  finanzamtDocumentUploadBanner = 'FINANZAMT_DOCUMENT_UPLOAD_BANNER',
  addInvoiceIBANBanner = 'addInvoiceIBANBanner',
  E_InvoiceOnboardingAlert = 'E_InvoiceOnboardingAlert',
  // tooltips
  emailTrackingTooltip = 'emailTrackingTooltip',
  emailZugferdTooltip = 'emailZugferdTooltip',
  saveAndDownloadZugferdTooltip = 'saveAndDownloadZugferdTooltip',
  makeRecurringTooltip = 'makeRecurringTooltip',

  // documents repository
  repositoryDocumentFormInvoice = 'repositoryDocumentFormInvoice',
}
